import { useMutation as r } from "@tanstack/react-query";
import { customInstance as c } from "../../mutator/custom-instance.es.js";
const y = (t, n, e, a) => c({
  url: `/api/booking_requests/${t}/payment_intents`,
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  data: n,
  signal: a
}, e), d = (t) => {
  const n = ["createBookingRequestPaymentIntent"], {
    mutation: e,
    request: a
  } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : {
    ...t,
    mutation: {
      ...t.mutation,
      mutationKey: n
    }
  } : {
    mutation: {
      mutationKey: n
    },
    request: void 0
  };
  return {
    mutationFn: (o) => {
      const {
        bookingRequestId: u,
        data: i
      } = o ?? {};
      return y(u, i, a);
    },
    ...e
  };
}, O = (t) => {
  const n = d(t);
  return r(n);
}, q = (t, n, e, a) => c({
  url: `/api/booking_requests/${t}/payment_intents/${n}`,
  method: "PATCH",
  headers: {
    "Content-Type": "application/json"
  },
  data: e
}, a), I = (t) => {
  const n = ["updateBookingRequestPaymentIntent"], {
    mutation: e,
    request: a
  } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : {
    ...t,
    mutation: {
      ...t.mutation,
      mutationKey: n
    }
  } : {
    mutation: {
      mutationKey: n
    },
    request: void 0
  };
  return {
    mutationFn: (o) => {
      const {
        bookingRequestId: u,
        paymentIntentId: i,
        data: s
      } = o ?? {};
      return q(u, i, s, a);
    },
    ...e
  };
}, h = (t) => {
  const n = I(t);
  return r(n);
}, p = (t, n, e, a, m) => c({
  url: `/api/booking_requests/${t}/payment_intents/${n}/attach_customer`,
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  data: e,
  signal: m
}, a), g = (t) => {
  const n = ["attachCustomerToPaymentIntent"], {
    mutation: e,
    request: a
  } = t ? t.mutation && "mutationKey" in t.mutation && t.mutation.mutationKey ? t : {
    ...t,
    mutation: {
      ...t.mutation,
      mutationKey: n
    }
  } : {
    mutation: {
      mutationKey: n
    },
    request: void 0
  };
  return {
    mutationFn: (o) => {
      const {
        bookingRequestId: u,
        paymentIntentId: i,
        data: s
      } = o ?? {};
      return p(u, i, s, a);
    },
    ...e
  };
}, R = (t) => {
  const n = g(t);
  return r(n);
};
export {
  p as attachCustomerToPaymentIntent,
  y as createBookingRequestPaymentIntent,
  g as getAttachCustomerToPaymentIntentMutationOptions,
  d as getCreateBookingRequestPaymentIntentMutationOptions,
  I as getUpdateBookingRequestPaymentIntentMutationOptions,
  q as updateBookingRequestPaymentIntent,
  R as useAttachCustomerToPaymentIntent,
  O as useCreateBookingRequestPaymentIntent,
  h as useUpdateBookingRequestPaymentIntent
};
